import { put } from "redux-saga/effects";

export function* putInStore(actionType, data) {
  return yield put({ type: actionType, payload: data });
}

export const allDevicesSelector = (state) => state.autonomos.devices.allDevices;
export const deviceListSelector = (state) => state.autonomos.devices.list;
export const deviceDictionarySelector = (state) =>
  state.autonomos.devices.dictionary;
export const selectedProductsSelector = (state) => state.autonomos.products;
